<template>
    <div class="main_contain">
        <div class="main_head">
            <div class="main_head_content">
                <div class="main_head_title" @click="goHome">天津市科协人才项目管理系统</div>
                <div class="main_mine">
                    <Dropdown trigger="click" @on-click="clickTitleDropdown">
                        <a href="javascript:void(0)">
                            <img src="@/assets/head_mine.png" />
                            你好，{{ this.$store.state.user.realName }}
                            <Icon type="ios-arrow-down"></Icon>
                        </a>
                        <DropdownMenu slot="list">
                        <DropdownItem name="ModifyPassword">修改密码</DropdownItem>
                        <DropdownItem name="logout">退出登录</DropdownItem>
                    </DropdownMenu>
                    </Dropdown>
                </div>
            </div>
        </div>
        <div class="main_content">
            <router-view />
        </div>
        <modify-password-modal ref="modifyPasswordModal"></modify-password-modal>
    </div>
</template>
<script>
import ModifyPasswordModal from '@/components/ModifyPasswordModal.vue';
import store from '@/store'
export default {
    components: { ModifyPasswordModal },
    name: 'main-contain',
    data() {
        return {
        }
    },
    beforeRouteEnter (to, from, next) {
        store.dispatch('getUserInfo').then(() => {
            store.dispatch('getUserInfo').then(() => {
                next()
            })
        })
    },
    methods: {
        // 回到首页
        goHome () {
            if (this.$store.state.user.is_govern * 1 === 0) {
                // 申报人 
                this.$router.push('/')
            } else {
                // 单位
                this.$router.push('/trainingUnitIndex')
            }
        },
        clickTitleDropdown(name) {
            if (name === 'logout') {
                this.axios.post('/webapi/web/logout')
                    .then(res => {
                        let data = res.data
                        if (data.code === 200) {
                            this.$router.push({ name: 'login' })
                        } else {
                            this.$Message.error(data.msg)
                        }
                    })
            } else if (name === 'ModifyPassword') {
                this.$refs.modifyPasswordModal.showModalView();
            }
        }
    }
}
</script>
<style lang="less" scoped>
.main_contain {
    // 撑满视口高度，并垫上背景图底部的同色底色，
    // 避免内容不足一屏时页面底部露出 #app 的纯白底色形成白条
    min-height: 100%;
    background-color: #f7fafd;
    .main_head {
        background-color: #f7fafd;
        .main_head_content {
            width: 1200px;
            height: 60px;
            line-height: 60px;
            margin: 0 auto;
            .main_head_title {
                font-size: 18px;
                color: #000000;
                display: inline-block;
                cursor: pointer;
            }
            .main_mine {
                float: right;
                a {
                    color: #000000;
                    &:hover {
                        color: #2266ff;
                    }
                }
                img {
                    vertical-align: middle;
                    margin-top: -4px;
                    margin-right: 8px;
                }
            }
        }
    }
    .main_content {
        background: url('@/assets/common-bg.png') no-repeat;
        background-size: 100% auto;
        background-color: #f7fafd;
        min-height: 600px;
    }
}
</style>
